const updateIn = (path = [], mutator, obj) => {
  if (!path.length) return obj
  const lastIndex = path.length - 1
  let node = obj
  for (const [index, p] of path.entries()) {
    if (lastIndex != index && (null == node[p] || !['object', 'function'].includes(typeof node[p]))) {
      node[p] = {}
    } else if (lastIndex == index) {
      node[p] = mutator(node[p])
    }
    node = node[p]
  }
  return obj
}

const setIn = (path = [], value, obj) => updateIn(path, () => value, obj)

export { updateIn, setIn }
